export const loadRzp = () => new Promise((res) => {
  if (window.Razorpay) return res(true);
  const s = document.createElement("script"); s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => res(true); s.onerror = () => res(false); document.body.appendChild(s);
});

// Razorpay checkout with server-side status polling, so UPI QR / intent payments finish even if the
// checkout never calls back. The server decides every status from Razorpay's own record.
export async function openCheckout({ api, o, name = "Altiora Ventures", description, prefill, onDone }) {
  if (!(await loadRzp())) throw new Error("Could not load the payment window. Check your connection.");
  let done = false;
  let timer = null;
  let rz = null;
  const finish = (status, message) => {
    if (done) return;
    done = true;
    clearInterval(timer);
    try { rz?.close(); } catch { /* already closed */ }
    onDone(status, message);
  };
  const check = async () => {
    try { const r = (await api.get(`/payments/status/${o.order_id}`)).data; if (r.status === "paid") finish("paid"); return r; } catch { return null; }
  };
  const watchAfterClose = (ms) => {
    const until = Date.now() + ms;
    clearInterval(timer);
    timer = setInterval(async () => {
      const r = await check();
      if (!done && (Date.now() > until || (r && r.status === "failed"))) finish(r?.status === "failed" ? "failed" : "pending", r?.message);
    }, 4000);
  };
  rz = new window.Razorpay({
    key: o.key_id, order_id: o.order_id, amount: o.amount_minor, currency: o.currency, name, description, prefill: prefill || o.prefill, theme: { color: "#0b3d2e" },
    handler: async (resp) => {
      try { const v = (await api.post("/payments/verify", resp)).data; if (v.status === "paid") return finish("paid"); } catch { /* fall through to polling */ }
      watchAfterClose(180000);
    },
    modal: {
      ondismiss: async () => {
        if (done) return;
        try {
          const r = (await api.post(`/payments/cancel/${o.order_id}`)).data;
          if (r.status === "paid") return finish("paid");
          if (r.status === "cancelled") return finish("cancelled", r.message);
          watchAfterClose(180000);
        } catch { finish("cancelled"); }
      },
    },
  });
  rz.on("payment.failed", () => { /* customer can retry inside the same window; final status comes from the server */ });
  rz.open();
  timer = setInterval(check, 4000);
}

export const PAY_MSG = {
  paid: "Payment received and verified by Altiora. Thank you!",
  failed: "The payment failed. You have not been charged by Altiora.",
  pending: "Your bank is still confirming the payment. This page will update automatically; please don't pay again.",
  cancelled: "Payment cancelled. You have not been charged.",
};
